<template>
	<el-row :gutter="20">
		<el-col
			v-loading="isLoading"
			:span="24"
			style="height: auto; padding: 1rem; background: #ffffff"
		>
			<div class="bg-white">
				<div class="text-right">
					<span class="switch-graph__title pr-4">
						<span
							class="cursor-pointer"
							:class="selectedGraphValueType == 'yes' ? 'active' : ''"
							@click="selectedGraphValueType = 'yes'"
							>MOST YES</span
						>
						|
						<span
							class="cursor-pointer"
							:class="selectedGraphValueType == 'no' ? 'active' : ''"
							@click="selectedGraphValueType = 'no'"
							>MOST NO</span
						>
					</span>
					<span
						:disabled="load_steps_report_data"
						class="link-text cursor-pointer"
						@click="viewDetails = !viewDetails"
						>{{ viewDetails ? "Hide" : "View" }} Details</span
					>
				</div>
				<div class="grid-content text-center" style="margin: 1rem 0">
					<h4>Performance - By Steps</h4>
				</div>
				<el-row :gutter="20" type="flex" class="row-bg" justify="center">
					<el-col :span="4">
						<span style="background-color: #d26300; padding: 0 18px"></span
						>&nbsp;Yes
					</el-col>
					<el-col :span="4">
						<span style="background-color: #cf8c53; padding: 0 18px"></span
						>&nbsp;No
					</el-col>
				</el-row>
				<steps-insight-dashboard-graph
					:graph-values="graphValues"
					:graph-labels="graphLabels"
					:graph-colors="graphColors"
				></steps-insight-dashboard-graph>
				
			</div>
		</el-col>
		<el-row :gutter="20">
			<el-col :span="24">
				<StepPerformanceDetails
					:view-details="viewDetails"
					:chart-options="chartOptions"
					:chart-data="chartData"
					:height="300"
					:plugins="plugins"
					:performance-results="stepsList"
					:outlet="outlet"
					:intermediate-category="intermediateCategory"
					:from-date="fromDate"
					:to-date="toDate"
					:dashboard-tab="dashboardTab"
					@closeStepsInsightsDetailsModal="handleCloseLocationPerformanceDetails"
				>
					<slot></slot>
				</StepPerformanceDetails>
			</el-col>
		</el-row>
	</el-row>
</template>

<script>
import StepsInsightDashboardGraph from "./StepsPerformanceDetails/StepsInsightDashboardGraph.vue";
import { EventBus } from "../../../../../eventBus";
import StepPerformanceDetails from "./StepsPerformanceDetails/StepPerformanceDetails.vue";
import labourPlanningService from "../../../../../services/labourPalnningService";
let chartInstance;
export default {
	name: "StepsInsights",
	components: {
		StepPerformanceDetails,
		StepsInsightDashboardGraph
	},
	props: {
		intermediateCategory: {
			type: String,
			default: "",
		},
		dashboardTab: {
			type: String,
			default: "audit",
		},
		fromDate: {
			type: String,
			default: "",
		},
		toDate: {
			type: String,
			default: "",
		},
		outlet: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			selectedGraphValueType: "yes",
			load_steps_report_data: true,
			plugins: {
				datalabels: {
					display: false,
				},
			},
			chartOptions: {
				indexAxis: "y",
				elements: {
					bar: {
						borderWidth: 2,
					},
				},
				plugins: {
					datalabels: {
						color: "black",
					},
				},
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false,
				},
				scales: {
					x: {
						stacked: true,
					},
					y: {
						stacked: true,
					},
				},
			},
			chartData: {
				labels: [],
				datasets: [
					{
						label: "Yes",
						backgroundColor: [],
						data: [],
						borderWidth: 2,
					},
				],
				plugins: [],
			},
			stepsList: [],
			viewDetails: false,
			isLoading: false,
			graphColors: [],
			graphLabels: [],
			graphValues: [],
		};
	},
	computed: {
		chartDataLabel() {
			if (this.selectedGraphValueType == "yes") {
				return "Yes";
			} else {
				return "No";
			}
		},
	},
	watch: {
		intermediateCategory(newValue, oldValue) {
			this.getStepsInfo();
		},
		dashboardTab(oldValue, newValue) {
			this.getStepsInfo();
		},
		fromDate(newValue, oldValue) {
			this.getStepsInfo();
		},
		toDate(newValue, oldValue) {
			this.getStepsInfo();
		},
		outlet(newValue, oldValue) {
			this.getStepsInfo();
		},
		viewDetails(value) {
			if (value === true) {
				EventBus.$emit("initializeTaskStepInsightsGraph", true);
			} else if (value === false) {
				EventBus.$emit("destroyTaskStepInsightsGraph", true);
			}
		},
		selectedGraphValueType(newValue, oldValue) {
			this.getStepsInfo();
		},
	},
	async mounted() {
		const self = this;
		EventBus.$on("callAllGraphs", async (payload) => {
			await self.getStepsInfo();
		});
		EventBus.$on("fetchGraphDetails", async (payload) => {
			await self.getStepsInfo();
		});
		EventBus.$on("insightsDateUpdated", async (payload) => {
			await self.getStepsInfo();
		});
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		handleCloseLocationPerformanceDetails() {
			this.viewDetails = false;
		},
		wordCase(str) {
			let splitStr = str.toLowerCase().split(' ');
			for (let i = 0; i < splitStr.length; i++) {
					splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
			}
			return splitStr.join(' '); 
		},
		async getStepsInfo() {
			if (this.fromDate && this.toDate && !this.isLoading) {
				this.isLoading = true;
				const params = {
					start_date: this.fromDate,
					end_date: this.toDate,
					filters: {
						outlets: [],
					},
					main_category: this.dashboardTab,
					intermediate_category: this.intermediateCategory,
					sort_by: this.selectedGraphValueType == 'yes' ? 'yes_percentage'  : 'no_percentage',
				};
				if (this.outlet) {
					params.filters.outlets.push(this.outlet);
				}
				this.load_steps_report_data = true;
				await labourPlanningService.getStepLocations(params)
					.then((response) => {
						const results = JSON.parse(response.data);
						const responseData = results.results;
						this.stepsList = [...responseData];
						this.load_steps_report_data = false;
						let localArr = [];
						for (let i = 0; i < responseData.length; i++) {
							let check = localArr.find(
								(el) => el.name == responseData[i].name
							);

							if (check === undefined) {
								localArr.push({
									name: responseData[i].name,
									total_yes: responseData[i].yes,
									total_no: responseData[i].no,
									total_yes_percentage: responseData[i].yes_percentage,
									total_no_percentage: responseData[i].no_percentage,
								});
							} else {
								let checkIndex = localArr.findIndex((el) => el.name == responseData[i].name);
								localArr[checkIndex].total_yes = localArr[checkIndex].total_yes + responseData[i].yes;
								localArr[checkIndex].total_no = localArr[checkIndex].total_no + responseData[i].no;
								if (responseData[i].yes_percentage > localArr[checkIndex].total_yes_percentage) {
									localArr[checkIndex].total_yes_percentage = responseData[i].yes_percentage;
								}
								if (responseData[i].no_percentage > localArr[checkIndex].total_no_percentage) {
									localArr[checkIndex].total_no_percentage = responseData[i].no_percentage;
								}
							}
						}
						
						if (this.selectedGraphValueType == "yes") {
							localArr.sort((a, b) => b.total_yes_percentage - a.total_yes_percentage);
							this.chartData.datasets[0].label = "Yes";
						} else {
							this.chartData.datasets[0].label = "No";
							localArr.sort((a, b) => b.total_no_percentage - a.total_no_percentage);
						}

						let labelsArr = [];
						let backgroundColors = [];
						let localArrData = [];

						for (let i = 0; i < localArr.length; i++) {
							labelsArr.push(this.wordCase(localArr[i].name));
							if (this.selectedGraphValueType == "yes") {
								backgroundColors.push("#d26300");
								localArrData.push(localArr[i].total_yes_percentage);
							} else {
								backgroundColors.push("#cf8c53");
								localArrData.push(localArr[i].total_no_percentage);
							}
						}
						this.chartData.labels = labelsArr.splice(0, 9);
						this.chartData.datasets[0].backgroundColor = backgroundColors.splice(0, 9);
						this.chartData.datasets[0].data = localArrData.splice(0, 9);

						this.graphLabels = [...labelsArr.reverse()];
						this.graphColors = [...backgroundColors.reverse()];
						this.graphValues = [...localArrData.reverse()];

						
					})
					.catch((error) => {
						console.error(error);
						this.load_steps_report_data = false;
						this.$notify.error({
							title: "Error",
							message: "Steps Insights!",
						});
					})
					.finally((result) => {
						if (chartInstance) {
							chartInstance.destroy();
						}
						this.isLoading = false;
					});
			}
		},
		excerptText(text, length = 20, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
	},
};
</script>

<style scoped>
* {
	margin: 0;
	padding: 0;
}

#category-echarts-container {
	background: #ffffff;
	position: relative;
	height: 300px;
	overflow: hidden;
}

.link-text {
	color: #d26300;
	text-decoration: underline;
	font-size: 12px;
}

.switch-graph__title {
	color: #d26300;
	padding-right: 35px;
	font-size: 14px;
	font-weight: 600;
}

.switch-graph__title .active {
	text-decoration: underline;
	font-weight: 700;
}
</style>
